function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { Deferred } from "../deferred/Deferred";
/**
 * Stores singletons and factory deferreds for a locator.
 */ var LocatorStorage = function LocatorStorage(options) {
    "use strict";
    _class_call_check(this, LocatorStorage);
    /**
   * Name of the locators associated with the storage.
   */ _define_property(this, "name", void 0);
    /**
   * Whether or not to detect cyclic depdencies between factories.
   */ _define_property(this, "cycleDetectionEnabled", void 0);
    _define_property(this, "singletonPromises", new Map());
    /**
   * Map of callbacks to execute when a factory for the given singleton ID has been provided.
   */ _define_property(this, "whenDefinedHooks", new Map());
    _define_property(this, "factoryDeferreds", new Map());
    this.name = options.name;
    this.cycleDetectionEnabled = options.cycleDetectionEnabled;
};
/**
 * This is implementation details of Locator, created so that helper variables to detect cyclic dependencies are not
 * accidentally passed into the constructor of Locator outside of Locator implementation.
 */ var LocatorImpl = /*#__PURE__*/ function() {
    "use strict";
    function LocatorImpl(_storage) {
        var _ancestorSingletons = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
        _class_call_check(this, LocatorImpl);
        _define_property(this, "_storage", void 0);
        _define_property(this, "_ancestorSingletons", void 0);
        this._storage = _storage;
        this._ancestorSingletons = _ancestorSingletons;
    }
    _create_class(LocatorImpl, [
        {
            key: "_log",
            value: /**
   * Log input messages.
   */ function _log(_message) {}
        },
        {
            key: "name",
            get: /**
   * Get name of the locator.
   */ function get() {
                return this._storage.name;
            }
        },
        {
            key: "cycleDetectionEnabled",
            get: /**
   * Get whether or not cyclic dependency detection is enabled.
   */ function get() {
                return this._storage.cycleDetectionEnabled;
            },
            set: /**
   * Set whether or not to enable cyclic dependency detection.
   */ function set(enabled) {
                this._storage.cycleDetectionEnabled = enabled;
            }
        },
        {
            /**
   * Add a factory to the Locator with a given ID. The ID must be declared in the `LocatorMap`,
   * and the factory must return a promise that is resolved with the singleton once it's constructed.
   * The factory may await other singletons from the Locator. Note that the factory is not called
   * immediately upon registration, but only when someone first requests the singleton; if you want
   * to eagerly initialize the singleton, simply `get()` it immediately after calling `set()`.
   */ // Note: If changing the public signature of this API, recheck that the associated compilation tests
            // in Locator.spec.ts (with // @ts-expect-error) actually still properly fail to compile with a type error,
            // by removing the @ts-expect-error line and recompiling, instead of failing for some other reason.
            key: "set",
            value: function set(id, factory) {
                // The singleton promise exists and the factory deferred has been removed => The factory has already been set previously.
                if (this._storage.singletonPromises.has(id) && !this._storage.factoryDeferreds.has(id)) {
                    throw new Error("Locator.set(): attempting to set new factory for singleton ".concat(id, " that already has one"));
                }
                var factoryDeferred = this._getOrMakeFactoryDeferred(id);
                if (factoryDeferred.isSettled) {
                    throw new Error("Locator.set(): attempting to set new factory for singleton ".concat(id, " that already has one"));
                }
                factoryDeferred.resolve(factory);
                this._log("Locator.set(): factory for ".concat(id));
                var whenDefinedHooks = this._storage.whenDefinedHooks.get(id);
                if (whenDefinedHooks) {
                    this._log("Locator.set(): running ".concat(whenDefinedHooks.size, " whenDefined hooks for ").concat(id));
                    whenDefinedHooks.forEach(function(hook) {
                        return hook();
                    });
                }
                // The hooks have all been executed and are no longer needed at this point.
                this._storage.whenDefinedHooks.delete(id);
            }
        },
        {
            key: "_getOrMakeFactoryDeferred",
            value: /**
   * Gets the existing Deferred for the factory for a given singleton ID, or makes one if we didn't already had one.
   * This allows us to get and set singletons out of order.
   */ function _getOrMakeFactoryDeferred(id) {
                //@ts-ignore
                var factoryDeferred = this._storage.factoryDeferreds.get(id);
                if (!factoryDeferred) {
                    factoryDeferred = new Deferred();
                    //@ts-ignore
                    this._storage.factoryDeferreds.set(id, factoryDeferred);
                }
                return factoryDeferred;
            }
        },
        {
            /**
   * Returns a parameter-less resolver function that can be invoked and awaited for in order to get the value, similar
   * to how {@link Locator#get} is used. The difference is that the resolver function is parameter-less, and can be
   * passed around to an interested party that will use it to get the value, without even knowing that internally it
   * just uses {@link Locator#get}, and without having a reference to the Locator instance itself.
   *
   * Modules that need to get some value from a Locator instance on demand could easily require resolver functions as
   * constructor arguments like they usually require dependencies, and invoke/await for the result when they actually
   * need it. This eliminates the direct dependency link between platform infrastructure code (Locator) and modules
   * that contain actual business logic.
   *
   * @param id - the ID of the value that will be eventually resolved.
   * @returns A parameter-less async function that will eventually resolve the requested value when invoked & awaited.
   */ key: "getResolver",
            value: function getResolver(id) {
                var _this = this;
                // Because a resolved can be used to resolve cyclic dependencies, by emptying the ancestor singletons,
                // we break the dependency detection chain for the resolver itself and not the decendants of the resolver.
                return function() {
                    return new LocatorImpl(_this._storage, []).get(id);
                };
            }
        },
        {
            /**
   * Executes the provided hook callback whenever the factory for the given singleton ID has been provided.
   * The hook intentionally does not provide any parameters containing the singleton dependency. Instead, it is up
   * to consumers of the hook to get the dependency using {@link Locator#get} as they normally would.
   *
   * @param id - The ID of the singleton dependency.
   * @param hook - The callback to execute when the dependency factory has been provided.
   * @returns A lambda that will remove the hook if it still exists when the lambda is invoked.
   */ key: "whenDefined",
            value: function whenDefined(id, hook) {
                var _this = this;
                // The singleton promise exists and the factory deferred has been removed => The factory has already been set previously.
                // The hook can be called immediately.
                if (this._storage.singletonPromises.has(id) && !this._storage.factoryDeferreds.has(id)) {
                    hook();
                    return;
                }
                // Check if the factory already exists, and if so call the hook immediately.
                // It is up to the consumer of the hook to call Locator.get to get the dependency.
                var factoryDeferred = this._getOrMakeFactoryDeferred(id);
                if (factoryDeferred.isSettled) {
                    hook();
                    return;
                }
                var hooks = this._storage.whenDefinedHooks.get(id);
                if (!hooks) {
                    hooks = new Set();
                    this._storage.whenDefinedHooks.set(id, hooks);
                }
                hooks.add(hook);
                // Return a lambda that can be used to remove the hook.
                return function() {
                    var _this__storage_whenDefinedHooks_get;
                    return (_this__storage_whenDefinedHooks_get = _this._storage.whenDefinedHooks.get(id)) === null || _this__storage_whenDefinedHooks_get === void 0 ? void 0 : _this__storage_whenDefinedHooks_get.delete(hook);
                };
            }
        },
        {
            key: "get",
            value: /**
   * Get a singleton from the Locator. This can be called even before the singleton's factory is
   * registered via set(); the returned Promise will be resolved after the singleton is registered
   * and constructed. If a singleton fails to load within FACTORY_WARNING_TIMEOUT seconds, a warning
   * is logged, and if it fails to load within FACTORY_ERROR_TIMEOUT an error is logged to the console.
   */ // Note: If changing the public signature of this API, recheck that the associated compilation tests
            // in Locator.spec.ts (with // @ts-expect-error) actually still properly fail to compile with a type error,
            // by removing the @ts-expect-error line and recompiling, instead of failing for some other reason.
            function get(id) {
                var _this = this;
                return _async_to_generator(function() {
                    var _this__storage, cycleDetectionEnabled, singletonPromises, singletonPromise, singletonDeferred, factoryDeferred, factoryExceededTimeout, factoryProvidedWarningTimer, factoryProvidedErrorTimer, factory, factoryTimer, locator;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this._log("Locator.get(): singleton ".concat(id));
                                _this__storage = _this._storage, cycleDetectionEnabled = _this__storage.cycleDetectionEnabled, singletonPromises = _this__storage.singletonPromises;
                                if (cycleDetectionEnabled && _this._ancestorSingletons.includes(id)) {
                                    console.error("Locator: cyclic dependency encountered: ".concat(_this._ancestorSingletons.join("->"), "->").concat(id));
                                }
                                singletonPromise = singletonPromises.get(id);
                                if (singletonPromise) {
                                    return [
                                        2,
                                        singletonPromise
                                    ];
                                }
                                // First, store the promise. This has to happen synchronously, before the async window
                                // initiated by awaiting the factory promise. Otherwise, a race could cause two calls
                                // to `get()` to both enter this code.
                                singletonDeferred = new Deferred();
                                singletonPromise = singletonDeferred.promise;
                                singletonPromises.set(id, singletonPromise);
                                factoryDeferred = _this._getOrMakeFactoryDeferred(id);
                                factoryExceededTimeout = false;
                                factoryProvidedWarningTimer = setTimeout(function() {
                                    factoryExceededTimeout = true;
                                    console.warn("Locator: factory for ".concat(id, " not provided through Locator.set() within ").concat(Locator.FACTORY_WARNING_TIMEOUT, " ms"));
                                }, Locator.FACTORY_WARNING_TIMEOUT);
                                factoryProvidedErrorTimer = setTimeout(function() {
                                    console.error("Locator: factory for ".concat(id, " not provided through Locator.set() within ").concat(Locator.FACTORY_ERROR_TIMEOUT, " ms"));
                                }, Locator.FACTORY_ERROR_TIMEOUT);
                                return [
                                    4,
                                    factoryDeferred.promise
                                ];
                            case 1:
                                factory = _state.sent();
                                // The factory has been provided, so remove the factory deferred.
                                _this._storage.factoryDeferreds.delete(id);
                                clearTimeout(factoryProvidedWarningTimer);
                                clearTimeout(factoryProvidedErrorTimer);
                                if (factoryExceededTimeout) {
                                    // At minimum FACTORY_WARNING_TIMEOUT and potentially FACTORY_ERROR_TIMEOUT were exceeded
                                    // but the factory eventually was fulfilled.
                                    console.info("Locator: factory for ".concat(id, " has eventually fulfilled."));
                                }
                                factoryTimer = setTimeout(function() {
                                    console.error("Locator: factory for ".concat(id, " failed to finish running within ").concat(Locator.FACTORY_TIMEOUT, " ms"));
                                }, Locator.FACTORY_TIMEOUT);
                                if (cycleDetectionEnabled) {
                                    locator = new LocatorImpl(_this._storage, _to_consumable_array(_this._ancestorSingletons).concat([
                                        id
                                    ]));
                                    singletonDeferred.adopt(factory(locator));
                                } else {
                                    singletonDeferred.adopt(factory(_this));
                                }
                                return [
                                    4,
                                    singletonPromise
                                ];
                            case 2:
                                _state.sent();
                                clearTimeout(factoryTimer);
                                if (factoryExceededTimeout) {
                                    console.info("Locator: factory for ".concat(id, " has eventually fulfilled."));
                                }
                                return [
                                    2,
                                    singletonPromise
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getAll",
            value: function getAll(ids) {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- needed to implement generic get function
                        return [
                            2,
                            Promise.all(ids.map(function(id) {
                                return _this.get(id);
                            }))
                        ];
                    });
                })();
            }
        }
    ]);
    return LocatorImpl;
}();
/**
   * The max time a factory should finish running before an message is logged.
   */ _define_property(LocatorImpl, "FACTORY_TIMEOUT", 5000);
/**
   * The max time a factory should take to be provided or to return a singleton before a warning message is logged.
   */ _define_property(LocatorImpl, "FACTORY_WARNING_TIMEOUT", 10000);
/**
   * The max time a factory should take to be provided or to return a singleton before an error message is logged.
   */ _define_property(LocatorImpl, "FACTORY_ERROR_TIMEOUT", 20000);
/**
 * Locator is a container for dependencies, usable as an alternative to explicit dependency injection. Unlike
 * traditional DI frameworks, it performs all initialization asynchronously. This allows for async dependencies
 * to be handled automatically, and also makes it so entries can be registered even after they've been
 * requested. It also means that dependencies don't have to all be registered in the container in a single
 * monolithic location before initialization can start; packages can register and request dependencies from
 * the container independently, and the Promise tree will take care of settling everything in the right order
 * (as long as there are no circular dependencies and everything requested is eventually registered).
 *
 * 1. To setup a Locator (this should be done once per context, unless you need multiple special Locator instances that
 *    should be independent of any other existing instance):
 *
 * 1.1 Create or pick an existing dedicated map-like type that should explicitly list all the known Locator map entries
 *     which this Locator instance should be aware of. This can be achieved by using one of the following patterns:
 *
 *    * Use a predefined typescript interface that can be extended via interface merging. The existing code that uses
 *      the non-generic Locator API uses this method to extend the predefined {@link LocatorMap} interface).
 *
 *    * Use a predefined typescript interface that can extend and inherit some definitions from a base interface which
 *      could list commonly used entries.
 *
 *    * Use a custom type that can be defined using type composition (union or intersection). This pattern is useful
 *      when the Locator instance should be made aware of specific entries already listed in other predefined map-like
 *      types. These can be provided by other packages, modules or groups of modules that contribute to specific
 *      features.
 *
 *    * a combination of (and not limited to) the above.
 *
 *   Some examples can be found in the `Locator.spec.ts` tests suite.
 *
 * 1.2 Create a Locator instance and pass it to the factories/init methods that will use it.
 *
 * 2. To use the Locator:
 *
 * * Create an ID for your entry and add it to the Locator map type (interface or inline type) defined previously.
 *   By convention, if the entry is a class instance, the ID is typically the same as the name of class, but you can
 *   create multiple IDs that map to the same type (resulting in multiple entries of the same type). You should also be
 *   able to store entries that are not instances of some class (eg. primitives, plain objects, arrays, etc).
 *
 * * Optionally create an async factory function (typically a static method or a bare function) that takes an optional
 *   Locator as it's only argument. The factory should produce a value. If the value produced by the factory is an
 *   instance of a class that expects some dependencies to function correctly, the factory can request them from
 *   the Locator instance that was passed as argument, and can forward them to the object that it creates (eg. via
 *   constructor arguments, explicit property assignments, calls to setters or other methods, etc).
 *
 * * Register the factory with your ID using {@link Locator#set} on a Locator instance that knows about your ID.
 *   Alternatively, you can also use an inline async factory function, it should have the same effect. Typically,
 *   this Locator will be a global Locator passed in by some host (e.g. the authoring engine) into an async init method
 *   for your package. Your init method may provide factories to the Locator via `set()` for other packages to
 *   consume, and may also directly instantiate any within-package classes that depend on entries from
 *   the Locator but do not themselves need to be provided as dependencies to other packages.
 *
 * This pattern, where the asynchronicity and Locator access is encapsulated in a factory rather than part of
 * the class instance itself, makes it so that the class can be tested in the traditional fashion via synchronous
 * construction and have the dependencies (usually mocks) provided as constructor arguments manually.
 *
 * For examples of how this can be used, see Locator.spec.ts, and since this is already used extensively in
 * the authoring engine, you can also use that as real production code examples.
 *
 * @remarks
 *
 * Given the asynchronous nature of the Locator API, automatic injection of dependencies via decorators or other
 * mechanisms that rely on a synchronous API (automatically generated getters on class prototypes) is not possible
 * anymore. The recommended way of using this API is via Locator-aware factories or init functions/methods.
 *
 * Also, given the fact that lazy dependency resolution via dynamically generated property getters attached on class
 * prototypes, instantiating classes that have dependencies managed by a Locator will only be possible after all the
 * dependencies will be resolved (by the async factory function). This could potentially lead to performance issues, so
 * please be careful when you add dependencies managed by a Locator to core modules.
 *
 * If this is indeed an issue, you can mitigate it by passing the Locator itself to the constructor, and have the class
 * itself resolve it's dependencies when they are needed. However, this adds a hard dependency between business logic
 * and infrastructure code, and should be carefully analyzed, as it may be a symptom of a deeper or not immediately
 * visible architectural issue. You could maybe consider refactoring (eg. splitting) the class into smaller and more
 * manageable classes, and instantiate them as the need arises.
 */ export var Locator = /*#__PURE__*/ function(LocatorImpl) {
    "use strict";
    _inherits(Locator, LocatorImpl);
    function Locator() {
        var name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", cycleDetectionEnabled = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        _class_call_check(this, Locator);
        var storage = new LocatorStorage({
            name: name,
            cycleDetectionEnabled: cycleDetectionEnabled
        });
        return _call_super(this, Locator, [
            storage
        ]);
    }
    return Locator;
}(LocatorImpl);

//# sourceMappingURL=Locator.js.map